import { createSelector } from 'reselect';

import { selectGetConfigValue } from '@pressreader/config';

type AskViewGlobalConfig = {
    enabled: boolean;
    showTopBarItem: boolean;
};

export const selectAskViewGlobalConfig = createSelector(selectGetConfigValue, (getConfigValue): AskViewGlobalConfig => {
    const enabled = getConfigValue<boolean>('features.views.ask.enabled', false);
    const topBarItemEnabled = getConfigValue<boolean>('features.topbar.ask.enabled', false);

    return {
        enabled,
        showTopBarItem: enabled && topBarItemEnabled,
    };
});
